import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import ResponsiveWrapper from 'components/charts/ResponsiveWrapper';
import Pies, { PieLabel, Legends } from 'components/D3Charts/Pies';
import { makeStyles } from '@material-ui/core';
import { formatLocaleNumber } from 'helpers/emeaHelpers';

const useStyles = makeStyles(() => ({
    root: {
        height: ({ height }) => height / 1.8
    }
}));

const LaoDonutChart = (props) => {
    const { t } = useTranslation();
    const { xKey, yKey, height, loading, themeType, tooltipEvent, donutHeight, colorPalette, setDetails, customNoTextHeight = 1.9, ...rest } = props;

    const classeslao = useStyles({ height });
    const [data, setDataLaoChart] = useState([]);
    const [totalSum, setTotalSumValue] = useState(() => data.reduce((a, b) => a + b[yKey], 0));

    useEffect(() => {
        setDataLaoChart(rest.data.map(d => ({ ...d, total: d[yKey], value: d[yKey] })))
        setTotalSumValue(rest.data.reduce((a, b) => a + b[yKey], 0))
    }, [rest.data]);

    const svgDimensionslao = {
        width: rest.parentWidth,
        height
    }

    const centerPosition = [svgDimensionslao.width / 2, svgDimensionslao.height / (loading  ? 1.9 : customNoTextHeight)];

    const NoDataInfoText = () => {
        const text = loading ? "loading" : "no_data_found"
        return (
            <g transform={`translate(${centerPosition})`} data-testid={"no-data-found"}>
                <text textAnchor="middle" data-testid="noData" fill={themeType === "dark" ? "white" : "black"}>{t(text)}</text>
            </g>
        )
    }

    return (
        <div data-testid='donutChart' className={classeslao.root}>
            <svg width={svgDimensionslao.width} height={svgDimensionslao.height / 1.8}>
                {
                    (!totalSum || loading) ? <NoDataInfoText /> :
                        <g transform={"translate(" + svgDimensionslao.width / 2 + "," + svgDimensionslao.height / 3.5 + ")"}>
                            <Pies
                                data={data}
                                radius={70}
                                setDetails={setDetails}
                                setDetailsData={rest.setDetailsData}
                                xKey={xKey}
                                tooltipEvent={tooltipEvent}
                                colorPalette={colorPalette}
                                donutChart={rest.donutChart}
                                showSliceLabel={rest.showSliceLabel}
                                subtype={rest?.subtype}
                                valueType={rest?.valueType}
                            />
                            <PieLabel donutTitle={rest.donutTitle} title={t("total")} subtitle={formatLocaleNumber(totalSum)} />
                        </g>
                }
            </svg>
            {
                (!totalSum || loading) ? null :
                    <Legends {...rest} data={data} xKey={xKey} colorPalette={colorPalette} setDetails={setDetails} />
            }
        </div>
    )

}

export default ResponsiveWrapper(LaoDonutChart)